export default __webpack_public_path__ + "static/media/cus2.aa0c0084.svg";